import { render, staticRenderFns } from "./partner-assign-users-widget.vue?vue&type=template&id=5efabe61&"
import script from "./partner-assign-users-widget.vue?vue&type=script&lang=js&"
export * from "./partner-assign-users-widget.vue?vue&type=script&lang=js&"
import style0 from "./partner-assign-users-widget.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports